import React from 'react';
import {Box, TextField} from '@mui/material';
import {Typography} from '@mui/joy';

interface Props {
    titles: string[];
    onTitleChange: (index: number, value: string) => void;
}

const TitlesStep = ({titles, onTitleChange}: Props) => {
    return (
        <Box sx={{maxHeight: '45vh', overflowY: 'auto'}}>
            <Box sx={{display: 'flex', flexDirection: 'column', gap: 1.5, py: 1}}>
                {titles.map((title, index) => (
                    <Box key={index} sx={{display: 'flex', alignItems: 'center', gap: 1.5}}>
                        <Typography
                            level="body-sm"
                            sx={{color: 'text.secondary', width: '32px', textAlign: 'right', flexShrink: 0}}
                        >
                            {index + 1}.
                        </Typography>
                        <TextField
                            value={title}
                            onChange={(e) => onTitleChange(index, e.target.value)}
                            size="small"
                            fullWidth
                            error={!title.trim()}
                        />
                    </Box>
                ))}
            </Box>
        </Box>
    );
};

export default TitlesStep;
